import { lazy, Suspense } from "react";
import SEOHead from "@/components/SEOHead";
import HeroSection from "@/components/home/HeroSection";
import TrustBar from "@/components/home/TrustBar";
import BestSellers from "@/components/home/BestSellers";

const LifestyleCarousel = lazy(() => import("@/components/home/LifestyleCarousel"));
const FeaturedProducts = lazy(() => import("@/components/home/FeaturedProducts"));
const KerClinicTrustSection = lazy(() => import("@/components/home/KerClinicTrustSection"));
const BenefitsGrid = lazy(() => import("@/components/home/BenefitsGrid"));
const TestimonialsSection = lazy(() => import("@/components/home/TestimonialsSection"));
const ComparisonTable = lazy(() => import("@/components/home/ComparisonTable"));
const FoundersStory = lazy(() => import("@/components/home/FoundersStory"));
const ProtocolSelector = lazy(() => import("@/components/home/ProtocolSelector"));
const BentoSection = lazy(() => import("@/components/home/BentoSection"));
const KerClinicSection = lazy(() => import("@/components/home/KerClinicSection"));
const SocialSection = lazy(() => import("@/components/home/SocialSection"));
const SurveySection = lazy(() => import("@/components/home/SurveySection"));

const SectionFallback = () => <div className="h-96" aria-hidden="true" />;

const Index = () => {
  return (
    <>
      <SEOHead
        title="Umbo — Suplementos de Hongos Funcionales | Biotecnología Mexicana"
        description="Suplementos de hongos funcionales con formulación clínica. Reishi, Lion's Mane, Cordyceps y Chaga con polisacáridos ≥30%. De México para México."
        path="/"
      />
      <HeroSection />
      <TrustBar />
      <BestSellers />
      <Suspense fallback={<SectionFallback />}>
        <LifestyleCarousel />
        <FeaturedProducts />
        <KerClinicTrustSection />
        <BenefitsGrid />
        <TestimonialsSection />
        <ComparisonTable />
        <FoundersStory />
        <ProtocolSelector />
        <BentoSection />
        <KerClinicSection />
        <SocialSection />
        <SurveySection />
      </Suspense>
    </>
  );
};

export default Index;
